import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { IImproveQscSummaryModel } from 'entities/ImproveQsc/ImproveQsc.models';
import { ImproveQscSummaryRow } from 'entities/ImproveQsc/components/ImproveQscSummaryRow';

interface IComponentProps {
  score: IImproveQscSummaryModel | null;
}

export const ImproveQscSummary: FC<IComponentProps> = ({ score }) => {
  return (
    <div>
      <Row align="middle" gutter={20} className="mb-4">
        <Col sm={8} xxl={10} className="ff-medium">
          Targets
        </Col>
        <Col span={3} className="ff-medium t-align-e">
          vs LP
        </Col>
        <Col span={3} className="ff-medium t-align-e">
          vs LY
        </Col>
        <Col sm={10} xxl={8} className="ff-medium">
          Trend
        </Col>
      </Row>

      <ImproveQscSummaryRow label="QSC" metric={score?.qsc} />
      <ImproveQscSummaryRow label="Q" metric={score?.q} />
      <ImproveQscSummaryRow label="S" metric={score?.s} />
      <ImproveQscSummaryRow label="C" metric={score?.c} />
    </div>
  );
};
